<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="left">&nbsp;</div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <ons-toolbar-button>
                    <router-link v-bind:to="{ name: 'Login' }" v-bind:title="'Login'">
                        <i class="fal fa-user"></i>
                    </router-link>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content">

            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <div class="content-inner">

                <div class="main-header">Reset password</div>

                <v-ons-list class="section-h list-no-divider">
                    <form @submit.prevent="submit">
                        <v-ons-list-item>
                            <div class="center">
                                <v-ons-input float placeholder="New password" type="password"
                                             v-model="form.password"></v-ons-input>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">
                                <v-ons-input float placeholder="Confirm new password" type="password"
                                             v-model="form.password_confirmation"></v-ons-input>
                            </div>
                        </v-ons-list-item>
                    </form>
                </v-ons-list>

                <section class="section-vh">
                    <gtc-button modifier="large" v-on:click="submit" v-bind:disabled="can_continue == false" class="primary">
                        Reset password
                    </gtc-button>
                </section>

            </div>

        </div>
    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        mounted(){

        },

        data () {
            return {
                app: this.$root.$data.app,
                form: {
                    password: '',
                    password_confirmation: '',
                },
                loading: false,
            }
        },

        methods: {

            submit(){

                this.loading = true

                const data = Object.assign({}, this.$route.params, this.form)

                this.app.http.post('user/resetpassword', data)
                    .then(response => {
                        this.loading = false
                        this.$ons.notification
                            .alert(response.data.message, { title: 'Success' })
                            .then(() => { this.$router.push({ name: 'Login' }) })
                    })
                    .catch(error => {
                        this.loading = false
                        this.$ons.notification
                            .alert(
                                this.app.getResponseErrorMessage(error),
                                { title: 'Unable to reset password' }
                            )
                    })
            }
        },

        computed: {

            ...mapGetters([
               'embed',
            ]),

            can_continue: function(){
                return this.form.password.length > 0 &&
                    this.form.password_confirmation.length > 0
            },

            show_loading: function(){
                return this.loading
            }
        },

        watch: {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/user/password_reset.vue